import {SessaoService} from '../../sessao/sessao.service';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Inject, Injectable, InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {first, switchMap} from 'rxjs/operators';

const AUTH_HEADER = 'Authorization';

export const SEGURANCA_CONFIGURATION = new InjectionToken('SEGURANCA_CONFIGURATION');

export interface SegurancaConfiguration {
  baseURl: string;
  tipoDispositivo: string;
  tokenStorageName?: string;
}

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
  constructor(
    private sessao: SessaoService,
    @Inject(SEGURANCA_CONFIGURATION) private config: SegurancaConfiguration) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      withCredentials: false,
      headers: req.headers || new HttpHeaders()
    });

    if (req.url.indexOf(this.config.baseURl) >= 0 &&
      !req.headers.get(AUTH_HEADER) || 'undefined' === req.headers.get(AUTH_HEADER)) {

      return this.sessao.token.pipe(first()).pipe(switchMap(token => {
        if (!!token) {
          req = req.clone({
            headers: req.headers.set(AUTH_HEADER, `Bearer ${token.raw}`)
          });
        } else {
          req = req.clone({
            headers: req.headers.set(AUTH_HEADER, `Device ${this.config.tipoDispositivo}@${this.sessao.device}`)
          });
        }

        return next.handle(req);
      }));

    }

    return next.handle(req);
  }

}
